<script lang="ts">
	import { getCataloguePositionTotal } from '../../../../helper/Calculation';
	import { formatBigWithLocale } from '../../../../helper/Parser';
	import type { PositionCataloguePositionVariant } from '../../../../types/CataloguesTypes';
	import type { SearchPositionCataloguePositionStore } from '../search/SearchPositionCataloguePositionStore.svelte';

	interface Props {
		store: SearchPositionCataloguePositionStore;
		variant: PositionCataloguePositionVariant;
		onClick: (e: MouseEvent) => void;
	}

	let { store, variant, onClick }: Props = $props();

	function getFormattedPrice(variant: PositionCataloguePositionVariant): string {
		//If we have a document selected use it
		if (document) {
			return formatBigWithLocale(
				getCataloguePositionTotal(variant, store.openDocument!.calculationFactors)
			);
		} else {
			//Should not be the case
			return 'No Document';
		}
	}
</script>

<button
	onclick={onClick}
	class="rounded-[5px] text-xs bg-primary-200 hover:bg-primary-100 text-white flex gap-2 px-2 py-1"
>
	{#if variant.name}
		<p class="truncate text-left">
			{variant.name}
		</p>
	{/if}
	{#if variant.unit}
		<p class="uppercase truncate">
			{variant.unit}
		</p>
	{/if}
	<p class="text-right">
		{getFormattedPrice(variant)}
	</p>
</button>
